import { render } from "./ShopModalPayment.vue?vue&type=template&id=306d4bd7"
import script from "./ShopModalPayment.vue?vue&type=script&lang=js"
export * from "./ShopModalPayment.vue?vue&type=script&lang=js"

import "@vueform/toggle/themes/default.css?vue&type=style&index=0&lang=css"

import exportComponent from "/Users/vixfs/PhpstormProjects/fitbase/frontend/web/vue-resources/personal-account/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__